import React, { useContext, useState } from 'react';
import { Item } from 'devextreme-react/form';
import FilieraContext from '../../../contexts/filieraContext';
import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Editing,
    Form,
    Button,
    Lookup,
    Format
} from 'devextreme-react/data-grid';
import { listiniMangimiDettaglioDataSource } from '../../../datasources/listiniMangimiDettagliDataSource';
import { tipiMangimiDataSource } from '../../../datasources/tipiMangimiDataSource';
import { TipiAnimaliDataSource } from '../../../datasources/tipiAnimaliDataSource';
import { dataGridErrorHandling } from '../../../utils/errorHandling';
import { capannoniDataSource } from '../../../datasources/capannoniDataSource';
import { ListinoDTO } from '../../../data';
import { Box, Switch } from 'devextreme-react';

type MangimiiTableProps = {
    listino: ListinoDTO,
    idListino: number,
    onChanged: ()=>void,
    readonly?: boolean
};

const MangimiDettaglio: React.FC<MangimiiTableProps> = (params) => {
    const { currentFiliera } = useContext(FilieraContext);
    const [ showAll, setShowAll ] = useState <boolean> (false);

    // useEffect(() => {
    //     console.log("Sono in Accasamenti table");

    //     console.log(idCiclo, idDocumento, currentIdFiliera);

    //     console.log(data);
    // }, []);

    const styles = {
        alignTitle: {
        marginLeft: "40px",
        marginRight: "40px",
        },
        fixSwitch: {
        width: "unset"
        }
    };

    return (
        <React.Fragment>
            <Box
                direction="row"
                width="100%"
                height={20}
                align="center"
                crossAlign="center">
                <Item colSpan={2}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ whiteSpace: 'nowrap' }}>Mostra tutti</span>
                        <Switch defaultValue={showAll} onValueChange={setShowAll} />
                    </div>
                </Item>
            </Box>
            <DataGrid
                className={'dx-card wide-card'}
                //dataSource={dataSource as any}
                dataSource={listiniMangimiDettaglioDataSource(params.idListino, showAll)}
                showBorders={false}
                focusedRowEnabled={true}
                defaultFocusedRowIndex={0}
                defaultSelectionFilter=""
                columnAutoWidth={true}
                errorRowEnabled={false}
                columnHidingEnabled={true}
                onRowUpdating={function (e) {
                    e.newData = Object.assign({}, e.oldData, e.newData);
                }}
                onRowRemoved={params.onChanged}
                onRowUpdated={params.onChanged}
                onRowInserted={params.onChanged}
                onDataErrorOccurred={dataGridErrorHandling}
            >
                <Editing mode="popup" allowUpdating={true}  allowDeleting={true} allowAdding={true}>
                    <Form labelMode='floating'>
                        <Item itemType="group" caption="Informazioni Listini Animali dettagliato" colCount={3} colSpan={2}>
                            <Item dataField="idTipoMangime" editorType="dxSelectBox" editorOptions={{ searchEnabled: true }} />
                            <Item 
                                    dataField="inizioValidita" 
                                    editorType="dxDateBox" 
                                    editorOptions={{
                                        type: 'date', // Ensures only the date is used
                                        displayFormat: 'yyyy-MM-dd', // Use a standard date format
                                        useMaskBehavior: true, // Ensures the format mask is applied
                                    }} 
                                />
                            <Item dataField="valore" editorType='dxNumberBox'/>
                        </Item>
                    </Form>
                </Editing>
                <Paging defaultPageSize={10} />
                <Pager showPageSizeSelector={true} showInfo={true} />
                <FilterRow visible={true} />

                <Column type="buttons">
                    <Button name="edit" />
                    <Button name="delete" />
                </Column>
                <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
                <Column dataField={'idListino'} width={90} allowEditing={false} visible={false} />
                <Column dataField={'idTipoMangime'} caption='Tipo mangime' >
                    <Lookup dataSource={tipiMangimiDataSource} valueExpr="id" displayExpr="descrizione" />
                </Column>
                <Column dataField={'inizioValidita'} alignment='right' width={200}/>
                <Column dataField={'valore'} caption='Prezzo/Capo' >
                    <Format type='currency' precision={4}></Format>
                </Column>
            </DataGrid>
        </React.Fragment>
    );
};

export default MangimiDettaglio;